import React from 'react';
import Btn, { BtnModifier } from '../../../../components/molecules/Btn';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { SVGIcon } from '../../../../components/atoms/SVG';

type AccordionItemExtraButtonProps = {
  svgSpriteId: SVGIcon;
  href: string;
  text: string;
};

export function AccordionItemExtraButton({ svgSpriteId, href, text }: AccordionItemExtraButtonProps) {
  return (
    <span className="accordion__icon-edit">
      <Btn
        modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
        href={href}
        svgSpriteId={svgSpriteId}
        type="button"
        text={text}
        titleText={text}
        hiddenText
        tooltipPlacement={TooltipPlacement.TOP}
      />
    </span>
  );
}
